"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var DlgViewText = /** @class */ (function (_super) {
    __extends(DlgViewText, _super);
    function DlgViewText(props) {
        return _super.call(this, props) || this;
    }
    DlgViewText.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                title: data.title,
                text: data.text
            });
        });
        this.setState({
            visible: this.props.controller.DATA.visible,
            title: this.props.controller.DATA.title,
            text: this.props.controller.DATA.text
        });
    };
    DlgViewText.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgViewText.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgViewText.prototype.render = function () {
        return (React.createElement(antd_1.Modal, { title: this.state.title, visible: this.state.visible, wrapClassName: "vertical-center-modal", closable: false, maskClosable: false, footer: React.createElement(antd_1.Button, { type: "primary", onClick: this.handleClose.bind(this) }, "OK") },
            React.createElement("div", { style: {
                    overflow: "auto",
                    // wordWrap: "break-word",
                    wordBreak: "break-all",
                    overflowWrap: "break-word",
                    whiteSpace: "pre",
                    height: "150px",
                    width: "100%",
                    maxWidth: "100%" //,
                    // hyphens: "auto"
                } }, this.state.text)));
    };
    return DlgViewText;
}(React.Component));
exports.default = DlgViewText;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ui/DlgViewText.tsx
// module id = 1720
// module chunks = 0